import { render, staticRenderFns } from "./SublistEvaluation.vue?vue&type=template&id=1523203e&"
import script from "./SublistEvaluation.vue?vue&type=script&lang=js&"
export * from "./SublistEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports